import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { 
  Box, 
  IconButton, 
  Typography
} from '@mui/material';

import useCompanyRole from '../hooks/useCompanyRole';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';

import CreatePopover from '../popover/CreatePopover';

import global from "../../global.scss";
import "./styles.scss";

const SideNavigation = ({
  currentPage,
  isNavExpanded,
  setIsNavExpanded,
}) => {
  const navigate = useNavigate();
  const other = useSelector(state => state.other);
  const companyRole = useCompanyRole();
  const [showNavExpandBtn, setShowNavExpandBtn] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const [createMenuOpen, setCreateMenuOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [createMenuAnchor, setCreateMenuAnchor] = useState(null);

  useEffect(() => {
    console.log(companyRole, "companyRole");
  }, [companyRole]);

  useEffect(() => {
    try { 
      formatSelectedCompany(other.selectedCompany || null);
    } catch (error) {
      console.log("ERR_TOP_NAV_2", error);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [other]);

  const formatSelectedCompany = (obj) => {
    setSelectedCompany(obj);
  };


  return (
    <Box 
      className={`nav__side ${isNavExpanded ? 'nav__side-expanded' : 'nav__side-collapsed'}`}
      onMouseEnter={() => {
        setShowNavExpandBtn(true);
      }}
      onMouseLeave={() => {
        setShowNavExpandBtn(false);
      }}
      display={"flex"} 
      flexDirection={"column"} 
      gap={"10px"}
      justifyContent={"space-between"}>
      <CreatePopover
        open={createMenuOpen}
        anchor={createMenuAnchor} 
        onClose={() => {
          setCreateMenuOpen(false);
        }}
        />

      <Box
        className="flex_SBColumn"
        height={"100%"}>
        <Box
          className="flex_CenterColumn"
          gap={"20px"}>
          <Box className="nav__side-conatiner">
            {
              selectedCompany?.Id === "1"
              ?
              <>
                <Box className={`${currentPage === 0 ? 'nav__side-selected' : 'nav__side-item'} 
                  ${isNavExpanded ? 'flexCenter_Row' : 'flexCenterCenterRow'}`}
                  onClick={() => navigate("/")}>
                  <DashboardOutlinedIcon 
                    sx={{ width: isNavExpanded ? "18.5px" : "24px" }}/>
                  {
                    isNavExpanded && 
                    <Typography 
                      variant='body2'
                      fontWeight={600}
                      sx={{ color: currentPage === 0 ? global['secondary'] : global['main_text'] }}>
                      Lookback Engine
                    </Typography>
                  }
                </Box>
                <Box className={`${'nav__side-item'} 
                  ${isNavExpanded ? 'flexCenter_Row' : 'flexCenterCenterRow'}`}
                  onClick={() => navigate("/")}>
                  <DashboardOutlinedIcon 
                    sx={{ width: isNavExpanded ? "18.5px" : "24px" }}/>
                  {
                    isNavExpanded && 
                    <Typography 
                      variant='body2'
                      fontWeight={600}
                      sx={{ color: global['main_text'] }}>
                      Live Audit (Restricted Wallet)
                    </Typography>
                  }
                </Box>
                <Box className={`${'nav__side-item'} 
                  ${isNavExpanded ? 'flexCenter_Row' : 'flexCenterCenterRow'}`}
                  onClick={() => navigate("/")}>
                  <DashboardOutlinedIcon 
                    sx={{ width: isNavExpanded ? "18.5px" : "24px" }}/>
                  {
                    isNavExpanded && 
                    <Typography 
                      variant='body2'
                      fontWeight={600}
                      sx={{ color: global['main_text'] }}>
                      Settings
                    </Typography>
                  }
                </Box>
              </>
              :
                selectedCompany?.Id === "2"
                ?
                <>
                  <Box className={`${currentPage === 0 ? 'nav__side-selected' : 'nav__side-item'} 
                    ${isNavExpanded ? 'flexCenter_Row' : 'flexCenterCenterRow'}`}
                    onClick={() => navigate("/")}>
                    <DashboardOutlinedIcon 
                      sx={{ width: isNavExpanded ? "18.5px" : "24px" }}/>
                    {
                      isNavExpanded && 
                      <Typography 
                        variant='body2'
                        fontWeight={600}
                        sx={{ color: currentPage === 0 ? global['secondary'] : global['main_text'] }}>
                        BOM Exception Triage
                      </Typography>
                    }
                  </Box>
                  <Box className={`${'nav__side-item'} 
                    ${isNavExpanded ? 'flexCenter_Row' : 'flexCenterCenterRow'}`}
                    onClick={() => navigate("/")}>
                    <DashboardOutlinedIcon 
                      sx={{ width: isNavExpanded ? "18.5px" : "24px" }}/>
                    {
                      isNavExpanded && 
                      <Typography 
                        variant='body2'
                        fontWeight={600}
                        sx={{ color: global['main_text'] }}>
                        Live Settlement (Wallet)
                      </Typography>
                    }
                  </Box>
                  <Box className={`${'nav__side-item'} 
                    ${isNavExpanded ? 'flexCenter_Row' : 'flexCenterCenterRow'}`}
                    onClick={() => navigate("/")}>
                    <DashboardOutlinedIcon 
                      sx={{ width: isNavExpanded ? "18.5px" : "24px" }}/>
                    {
                      isNavExpanded && 
                      <Typography 
                        variant='body2'
                        fontWeight={600}
                        sx={{ color: global['main_text'] }}>
                        CBP / FAA Reporting
                      </Typography>
                    }
                  </Box>
                </>
                :
                  selectedCompany?.Id === "3"
                  ?
                  <>
                    <Box className={`${currentPage === 0 ? 'nav__side-selected' : 'nav__side-item'} 
                      ${isNavExpanded ? 'flexCenter_Row' : 'flexCenterCenterRow'}`}
                      onClick={() => navigate("/")}>
                      <DashboardOutlinedIcon 
                        sx={{ width: isNavExpanded ? "18.5px" : "24px" }}/>
                      {
                        isNavExpanded && 
                        <Typography 
                          variant='body2'
                          fontWeight={600}
                          sx={{ color: currentPage === 0 ? global['secondary'] : global['main_text'] }}>
                          Restricted Wallet (Live Settlement)
                        </Typography>
                      }
                    </Box>
                    <Box className={`${'nav__side-item'} 
                      ${isNavExpanded ? 'flexCenter_Row' : 'flexCenterCenterRow'}`}
                      onClick={() => navigate("/")}>
                      <DashboardOutlinedIcon 
                        sx={{ width: isNavExpanded ? "18.5px" : "24px" }}/>
                      {
                        isNavExpanded && 
                        <Typography 
                          variant='body2'
                          fontWeight={600}
                          sx={{ color: global['main_text'] }}>
                          Form 28 Historical Lookback
                        </Typography>
                      }
                    </Box>
                    <Box className={`${'nav__side-item'} 
                      ${isNavExpanded ? 'flexCenter_Row' : 'flexCenterCenterRow'}`}
                      onClick={() => navigate("/")}>
                      <DashboardOutlinedIcon 
                        sx={{ width: isNavExpanded ? "18.5px" : "24px" }}/>
                      {
                        isNavExpanded && 
                        <Typography 
                          variant='body2'
                          fontWeight={600}
                          sx={{ color: global['main_text'] }}>
                          CBP Reporting
                        </Typography>
                      }
                    </Box>
                  </>
                  :
                  <></>
            }
          </Box>
        </Box>
      </Box>

      <Box className="nav__side-expand">
        {
          showNavExpandBtn
          &&
          <IconButton
            sx={{ backgroundColor: "#f1f1f1" }}
            onClick={() => {
              localStorage.setItem("navExpanded", !isNavExpanded);
              setIsNavExpanded(!isNavExpanded);
              setShowNavExpandBtn(false);
            }}>
            {
              isNavExpanded
              ?
              <ArrowBackIosNewIcon />
              :
              <ArrowForwardIosIcon />
            }
          </IconButton>
        }
      </Box>
    </Box>
  )
}

export default SideNavigation;